module.exports = __webpack_public_path__ + "static/media/feedback_2.f4e39fd3.png";